// extracted by mini-css-extract-plugin
export default {"Container":"dashboardBoxList__Container__cnF5j","ContentBox":"dashboardBoxList__ContentBox__y1HwB","ResultsMessage":"dashboardBoxList__ResultsMessage__qhhCg"};